import { useMemo } from 'react';
import { LessonTableType } from '../components/Lessons/TimetableVersion/Table/TimetableVersionLessonsTable';
import { lessonResponseToTableType } from '../components/Lessons/utils/lessonResponseToTableType';
import { LessonItemFragment, ListPlannedTeacherTeachingLoadQuery } from '../types/planung-graphql-client-defs';

export type LessonResponseToTableTypeProps = {
  queryLessonsData: LessonItemFragment[] | undefined;
  deputateByTeachersData: ListPlannedTeacherTeachingLoadQuery | undefined;
  versionContext: boolean;
};

export const useLessonResponseToTableType = ({
  versionContext,
  deputateByTeachersData,
  queryLessonsData,
}: LessonResponseToTableTypeProps): LessonTableType[] => {
  return useMemo(() => {
    return lessonResponseToTableType({
      versionContext,
      queryLessonsData,
      deputateByTeachersData: deputateByTeachersData?.plannedTeachingLoadByTeacher ?? [],
    });
  }, [queryLessonsData, deputateByTeachersData, versionContext]);
};
